import { render, staticRenderFns } from "./ExampleItineraries.vue?vue&type=template&id=36ec0d89&scoped=true&"
import script from "./ExampleItineraries.vue?vue&type=script&lang=js&"
export * from "./ExampleItineraries.vue?vue&type=script&lang=js&"
import style0 from "./ExampleItineraries.vue?vue&type=style&index=0&id=36ec0d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec0d89",
  null
  
)

export default component.exports